var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9594 7.04474L14.9251 2.86038C15.1209 2.01171 16.1738 1.70974 16.7897 2.3256L21.6744 7.21015C22.2903 7.82602 21.9883 8.87894 21.1396 9.07479L16.9552 10.0404C17.437 11.7835 16.8904 13.8594 15.375 15.3747C13.8596 16.8901 11.7837 17.4367 10.0406 16.955L9.07493 21.1396C8.87908 21.9883 7.82618 22.2903 7.2103 21.6744L2.32562 16.7899C1.70973 16.174 2.0117 15.1211 2.86039 14.9252L7.04484 13.9596C6.56297 12.2165 7.10956 10.1404 8.62504 8.62499C10.1404 7.10966 12.2163 6.56306 13.9594 7.04474Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandy);
export default __webpack_public_path__ + "static/media/candy.e3af54f9e3dc5f08a79faf51aedf88ca.svg";
export { ForwardRef as ReactComponent };